module.exports = __webpack_public_path__ + "img/mob2.23690703.png";